// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import {
  GroupSupervisoryStatusVariant,
  unionToGroupSupervisoryStatusVariant,
  unionListToGroupSupervisoryStatusVariant,
} from "./group-supervisory-status-variant";
import {
  NormalGroupSupervisoryStatus,
  NormalGroupSupervisoryStatusT,
  verifyNormalGroupSupervisoryStatus,
} from "./normal-group-supervisory-status";
import {
  ValuedGroupSupervisoryStatus,
  ValuedGroupSupervisoryStatusT,
  verifyValuedGroupSupervisoryStatus,
} from "./valued-group-supervisory-status";

export class ElevatorGroupSupervisoryStatusMessage implements flatbuffers.IUnpackableObject<ElevatorGroupSupervisoryStatusMessageT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): ElevatorGroupSupervisoryStatusMessage {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsElevatorGroupSupervisoryStatusMessage(
    bb: flatbuffers.ByteBuffer,
    obj?: ElevatorGroupSupervisoryStatusMessage,
  ): ElevatorGroupSupervisoryStatusMessage {
    return (obj || new ElevatorGroupSupervisoryStatusMessage()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsElevatorGroupSupervisoryStatusMessage(
    bb: flatbuffers.ByteBuffer,
    obj?: ElevatorGroupSupervisoryStatusMessage,
  ): ElevatorGroupSupervisoryStatusMessage {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new ElevatorGroupSupervisoryStatusMessage()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  statusType(): GroupSupervisoryStatusVariant {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : GroupSupervisoryStatusVariant.NONE;
  }

  status<T extends flatbuffers.Table>(obj: any): any | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__union(obj, this.bb_pos + offset) : null;
  }

  static startElevatorGroupSupervisoryStatusMessage(builder: flatbuffers.Builder) {
    builder.startObject(2);
  }

  static addStatusType(builder: flatbuffers.Builder, statusType: GroupSupervisoryStatusVariant) {
    builder.addFieldInt8(0, statusType, GroupSupervisoryStatusVariant.NONE);
  }

  static addStatus(builder: flatbuffers.Builder, statusOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, statusOffset, 0);
  }

  static endElevatorGroupSupervisoryStatusMessage(
    builder: flatbuffers.Builder,
  ): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 6); // status
    return offset;
  }

  static createElevatorGroupSupervisoryStatusMessage(
    builder: flatbuffers.Builder,
    statusType: GroupSupervisoryStatusVariant,
    statusOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    ElevatorGroupSupervisoryStatusMessage.startElevatorGroupSupervisoryStatusMessage(builder);
    ElevatorGroupSupervisoryStatusMessage.addStatusType(builder, statusType);
    ElevatorGroupSupervisoryStatusMessage.addStatus(builder, statusOffset);
    return ElevatorGroupSupervisoryStatusMessage.endElevatorGroupSupervisoryStatusMessage(builder);
  }

  unpack(): ElevatorGroupSupervisoryStatusMessageT {
    return new ElevatorGroupSupervisoryStatusMessageT(
      this.statusType(),
      (() => {
        const temp = unionToGroupSupervisoryStatusVariant(
          this.statusType(),
          this.status.bind(this),
        );
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })(),
    );
  }

  unpackTo(_o: ElevatorGroupSupervisoryStatusMessageT): void {
    _o.statusType = this.statusType();
    _o.status = (() => {
      const temp = unionToGroupSupervisoryStatusVariant(this.statusType(), this.status.bind(this));
      if (temp === null) {
        return null;
      }
      return temp.unpack();
    })();
  }

  unpackFields(...fields: string[]): ElevatorGroupSupervisoryStatusMessageT {
    const t = new ElevatorGroupSupervisoryStatusMessageT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("status_type")) {
      t.statusType = this.statusType();
    }
    if (fieldSet.has("status")) {
      t.status = (() => {
        const temp = unionToGroupSupervisoryStatusVariant(
          this.statusType(),
          this.status.bind(this),
        );
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })();
    }
    return t;
  }
}

export class ElevatorGroupSupervisoryStatusMessageT implements flatbuffers.IGeneratedObject {
  constructor(
    public statusType: GroupSupervisoryStatusVariant = GroupSupervisoryStatusVariant.NONE,
    public status: NormalGroupSupervisoryStatusT | ValuedGroupSupervisoryStatusT | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.status === null || this.status === undefined) {
      throw new Error('Required field "status" is not set');
    }
    const status = builder.createObjectOffset(this.status);

    return ElevatorGroupSupervisoryStatusMessage.createElevatorGroupSupervisoryStatusMessage(
      builder,
      this.statusType,
      status,
    );
  }

  clone(): ElevatorGroupSupervisoryStatusMessageT {
    const obj = new ElevatorGroupSupervisoryStatusMessageT();
    obj.statusType = this.statusType;
    obj.status =
      this.status !== null && typeof (this.status as any).clone === "function"
        ? (this.status as any).clone()
        : this.status;
    return obj;
  }

  equals(other: ElevatorGroupSupervisoryStatusMessageT): boolean {
    if (this.statusType !== other.statusType) return false;
    if (this.status !== null && other.status !== null) {
      if (typeof (this.status as any).equals === "function") {
        if (!(this.status as any).equals(other.status)) return false;
      } else if (this.status !== other.status) return false;
    } else if (this.status !== other.status) return false;
    return true;
  }
}

export function verifyElevatorGroupSupervisoryStatusMessage(
  verifier: flatbuffers.Verifier,
  tablePos: number,
): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 1);
    verifier.checkUnionConsistency(tablePos, 4, 6, "status");
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        const uType = verifier.readFieldUint8(tablePos, 4);
        switch (uType) {
          case 1: // NormalGroupSupervisoryStatus
            {
              const o = verifier.readInt32(pos);
              verifyNormalGroupSupervisoryStatus(verifier, pos + o);
            }
            break;
          case 2: // ValuedGroupSupervisoryStatus
            {
              const o = verifier.readInt32(pos);
              verifyValuedGroupSupervisoryStatus(verifier, pos + o);
            }
            break;
        }
      }
    }
    verifier.checkRequiredField(tablePos, 6, "status");
  } finally {
    verifier.popDepth();
  }
}
